// LO QUE SE LE DICE A LA PERSONA CUANDO SU PIN NO PASA (PANEL-PIN-UNIFICADO-T1, ASSIGN de Ares #24972).
//
// DE DONDE SALE. El kiosko de marcar decia "PIN incorrecto, intenta de nuevo" para todo lo que trajera "pin" en el
// texto, y la puerta del conteo (OperadorPin) decia "PIN incorrecto" para TODO: un PIN frenado, la red caida o un 500.
// Quien tiene el PIN bien y lee "incorrecto" lo vuelve a teclear, y cada fallo de verdad alarga el freno.
//
// LO QUE MANDA LA API (NexoAPI AsistenciaController, marcar y verify-pin; ProblemDetails con type .../problems/<x>):
//   422 pin_incorrecto  -> el PIN no es el de esa persona (el fallo se anota en el freno por colaborador)
//   429 pin_frenado     -> esa persona fallo muchas veces seguidas; detail: "... Espera N segundos ..."
//   429 sin ese type    -> la cerca por aparato (IP): muchos intentos desde este mostrador
//   400 no_pin          -> la persona todavia no tiene PIN
// El freno cuenta los fallos de marcar y de verify-pin juntos, por persona. El panel NO conoce ese contador: los
// intentos que quedan se dicen SOLO si la API los manda (intentosRestantes); si no, no se inventan.
// Retry-After no cruza al panel (la API no la expone por CORS, medido 10-oct): los segundos salen del detail.
//
// Sin DOM: lo prueba scripts/check-pin-respuesta.mjs.

const pick = (o, ...claves) => {
  for (const k of claves) if (o && o[k] !== undefined && o[k] !== null) return o[k];
  return null;
};

/** El slug del ProblemDetails (".../problems/pin_frenado" -> "pin_frenado"), en minusculas; '' si no hay. */
function tipoDe(details) {
  const t = pick(details, 'type', 'Type');
  return typeof t === 'string' ? t.split('/').pop().toLowerCase() : '';
}

/** "Duvan Andres Perez" -> "Duvan". */
function primerNombre(nombre) {
  const n = String(nombre ?? '').trim().split(/\s+/)[0];
  return n || '';
}

/** 45 -> "45 segundos"; 60 -> "1 minuto"; 300 -> "5 minutos"; null si no hay dato. */
export function cuantoFalta(segundos) {
  const s = Number(segundos);
  if (!Number.isFinite(s) || s <= 0) return null;
  if (s < 60) return `${Math.ceil(s)} segundos`;
  const m = Math.ceil(s / 60);
  return `${m} ${m === 1 ? 'minuto' : 'minutos'}`;
}

/** Los segundos del freno: del detail de la API ("Espera 60 segundos"), que es lo unico que llega al panel. */
function segundosDelFreno(details) {
  const d = String(pick(details, 'detail', 'Detail') ?? '');
  const m = d.match(/(\d+)\s*segundos?/i);
  return m ? Number(m[1]) : null;
}

/**
 * Lo que se le dice a la persona cuando la API no acepto su PIN.
 * @param {{ok:boolean, code?:any, error?:any, details?:object}} res  el CrudResult de ApiBase
 * @param {string} nombre  el nombre de la persona que esta tecleando
 * @returns {{tipo: 'incorrecto'|'frenado'|'aparato'|'sin-pin'|'conexion'|'otro', texto: string}}
 */
export function respuestaDelPin(res, nombre) {
  const quien = primerNombre(nombre);
  const status = Number(res?.code);
  const details = res?.details && typeof res.details === 'object' ? res.details : null;
  const tipo = tipoDe(details);

  if (tipo === 'pin_incorrecto' || status === 422) {
    // OJO: Number(null) es 0. Sin el dato de la API no hay cuenta (no se dice 'un error mas' por un cero que nadie mando).
    const crudo = pick(details, 'intentosRestantes', 'intentos_restantes', 'IntentosRestantes');
    const quedan = crudo === null || crudo === '' ? NaN : Number(crudo);
    const cola = Number.isInteger(quedan) && quedan >= 0
      ? (quedan === 0 ? ' Un error más y el PIN se frena un rato.' : ` Te ${quedan === 1 ? 'queda 1 intento' : `quedan ${quedan} intentos`} antes de que se frene.`)
      : ' Revísalo con calma: varios errores seguidos frenan el PIN un rato.';
    return { tipo: 'incorrecto', texto: `PIN incorrecto${quien ? ', ' + quien : ''}.${cola}` };
  }
  if (tipo === 'pin_frenado') {
    const falta = cuantoFalta(segundosDelFreno(details));
    return {
      tipo: 'frenado',
      texto: `${quien ? quien + ', tu' : 'Tu'} PIN quedó frenado por varios errores seguidos. ` +
        (falta ? `Espera ${falta}` : 'Espera un rato') + ' o pide ayuda al administrador.'
    };
  }
  if (status === 429) {
    return { tipo: 'aparato', texto: 'Se hicieron muchos intentos seguidos desde este aparato. Espera un minuto y vuelve a intentar.' };
  }
  if (tipo === 'no_pin') {
    return { tipo: 'sin-pin', texto: `${quien || 'Esta persona'} todavía no tiene PIN. Pídele al administrador que se lo ponga.` };
  }
  if (res?.code === 'NETWORK' || res?.code === 'TIMEOUT') {
    return { tipo: 'conexion', texto: 'No hay conexión con el sistema. Revisa el internet y vuelve a intentar.' };
  }
  if (status >= 500) {
    // El detail de un 500 es el ex.Message de la API (texto tecnico): a la persona se le dice que no es su PIN.
    return { tipo: 'otro', texto: 'El sistema tuvo un problema de su lado. No es tu PIN: vuelve a intentar en un momento.' };
  }
  const msg = typeof res?.error === 'string' && res.error.trim() ? res.error.trim() : 'No pudimos revisar el PIN ahora. Vuelve a intentar.';
  return { tipo: 'otro', texto: msg };
}
